export default (videoUrl: string): string => {
  const tvCom = 'http://static.tvcom.cz/';
  const shouldUseProxy = RegExp(tvCom);
  if (shouldUseProxy.test(videoUrl)) {
    const proxy = 'https://proxy.refrec.k42.dev/tvcom/';
    return videoUrl.replace(tvCom, proxy);
  }
  return videoUrl;
};
